<template>
    <div class="users">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>设备类型</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem 0 1rem; background-color: white">
            <el-form :inline="true" :model="query">
                <el-form-item label="设备名称:">
                    <el-input v-model="query.name" placeholder="设备名称"></el-input>
                </el-form-item>
                <el-form-item label="设备型号:">
                    <el-input v-model="query.model" placeholder="设备型号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onQuery">查询</el-button>
                    <el-button type="default" @click="query = {}">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div style="margin-top: 1rem; padding: 1rem; background-color: white">
            <el-button type="primary" style="margin-bottom: 1rem" @click="$router.push('/deviceType/create')" size="small">创建类型</el-button>
            <el-table
                    :data="devices"
                    border
                    stripe
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column
                        prop="name"
                        sortable
                        :sort-method="(a, b) => a.name ? a.name.localeCompare(b.name, 'zh') : -1"
                        label="设备名称">
                </el-table-column>
                <el-table-column
                        prop="model"
                        sortable
                        label="设备型号">
                </el-table-column>
                <el-table-column
                        prop="key1"
                        sortable
                        label="key1">
                </el-table-column>
                <el-table-column
                        prop="key2"
                        sortable
                        label="key2">
                </el-table-column>
                <el-table-column
                        prop="price"
                        sortable
                        label="充值价格">
                    <template slot-scope="scope">
                        {{scope.row.price}}元/次
                    </template>
                </el-table-column>
                <el-table-column
                        sortable
                        prop="creator"
                        label="创建人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="createTime"
                        label="创建时间"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updator"
                        label="更新人"
                >
                </el-table-column>
                <el-table-column
                        sortable
                        prop="updateTime"
                        label="更新时间"
                >
                </el-table-column>
                <el-table-column label="操作" v-if="auth.accountType != 1">
                    <template slot-scope="scope">
                        <el-button @click="$router.push('/deviceType/edit?id=' + scope.row.id)" type="text" size="small">编辑</el-button>
<!--                        <el-button @click="$router.push('/user/address?id=' + scope.row.id)" type="text" size="small">配送地址</el-button>-->
                        <el-button @click="deleteDevice(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div style="text-align: center">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.page"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
    import deviceApi from "../../api/deviceType";
    import {mapState} from "vuex";

    export default {
        data: function () {
            return {
                devices: [],
                enterprises: [],
                loading: false,
                total: 0,
                pagination: {
                    page: sessionStorage.getItem("page") || 1,
                    pageSize: 10
                },
                query: {

                },
            }
        },
        computed: {
            ...mapState("auth", {
                auth: state => state
            }),
        },
        mounted() {
            this.loadUsers();
        },
        methods: {
            deleteDevice: function(id) {
                this.$confirm('确定删除此设备类型？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    deviceApi.deleteById(id).then(result => {
                        this.loading = false;
                        this.loadUsers();
                    })
                });
            },
            loadUsers: function () {
                this.loading = true;
                deviceApi.listAll(this.query, this.pagination).then(result => {
                    this.loading = false;
                    this.devices = result.data;
                    this.total = result.total;
                })
            },
            onQuery: function () {
                this.pagination = {
                    ...this.pagination,
                    page: 1,
                }
                this.loadUsers();
            },
            handleSizeChange: function (size) {
                this.pagination = {
                    page: 1,
                    pageSize: size
                }
                this.loadUsers();
            },
            handleCurrentChange: function (page) {
                sessionStorage.setItem("page", page);
                this.pagination = {
                    ...this.pagination,
                    page: page,
                }
                this.loadUsers();
            },
            loadEnterprises: function () {
                enterpriseApi.getAll2().then(res => {
                    this.enterprises = res;
                })
            }
        }
    }
</script>
